export const CAVEONID_BASE = '/api'
export const RECAPTCHA_PUBLIC_KEY = '6Ld8G60dAAAAANcTH9IMRnvJY9WGZQDyr8i0FcpY'
export const POST_MESSAGE_DOMAIN = '*'
export const REFRESH_ACCESS_TOKEN_INTERVAL = 1800000
